import {createContext} from 'react';

const quienesSomosContext = createContext();

export default quienesSomosContext;